import React from "react";

function Footer() {
  return (
    <div className="footer ">
      <div className="container">
        <div className="row">
          <div className="col-md-3 col-xs-12">
            <ul>
              <li>
                <h3 className="widget__title">Home</h3>
                <div>
                  <ul className="menu">
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/#home-about"
                      >
                        Finblue Incubator Program
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/#home-benefits"
                      >
                        {" "}
                        Finblue Incubator Program Benefits
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/#home-categories"
                      >
                        Fintech Startup Sectors
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-3 col-xs-12">
            <ul>
              <li>
                <h3 className="widget__title">About Us</h3>
                <div>
                  <ul className="menu">
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#about-STPI"
                      >
                        {" "}
                        About STPI
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#about-finblue"
                      >
                        About Finblue Incubator Program
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#program-partners"
                      >
                        Program Partners
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/about-finblue-incubator-program/#chief-mentor"
                      >
                        Our Team
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-3 col-xs-12">
            <ul>
              <li>
                <h3 className="widget__title">The Program</h3>
                <div>
                  <ul className="menu">
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/fintech-incubator-program/#benefits-start-up"
                      >
                        Benefits to Start-up
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/fintech-incubator-program/#program-category"
                      >
                        Fintech Sectors
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/incubator-program/fintech-incubator-program/#eligibility"
                      >
                        Who can apply
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
          <div className="col-md-3 col-xs-12">
            <ul>
              <li>
                <h3 className="widget__title">Apply Now</h3>
                <div>
                  <ul className="menu">
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/finteract-2021/#"
                      >
                        PitchFest Apply Now
                      </a>{" "}
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/my-account/"
                      >
                        My Account
                      </a>
                    </li>
                    <li className="menu-item">
                      <a
                        rel="noreferrer noopener"
                        target="_blank"
                        href="https://finblue.stpi.in/sandbox-api/"
                      >
                        Sandbox API
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
